export default {
  lang: {
    choose: '语言/Language',
    zhcn: '简体中文',
    zhtw: '繁體中文(臺灣)',
    en: 'English',
    es: 'Español',
    ru: 'Русский',
    de: 'Deutsch',
    sv: 'Svenska',
    ja: '日本語',
    changeok: 'Cambio Idioma Satisfactorio'
  },
  btn: {
    ok: 'Aceptar',
    cancel: 'Cancelar',
    cont: 'Continuar'
  },
  menu: {
    upload: 'Subir',
    newfolder: 'Crear Carpeta',
    del: 'Borrar',
    up: 'Subir Nivel',
    refresh: 'Actualizar',
    dfu: 'DFU',
  },
  status: {
    connected: 'Conectado, Vers.: ',
    version: 'Versión:',
    mac: 'Dirección MAC:',
    loading: 'Cargando…',
  },
  conn: {
    connect: 'Conectar',
    connecting: 'Conectando…',
    disconnect: 'Desconectar…',
    consuccess: '¡El Pixl.js se ha Conectado correctamente!',
    disconnected: '¡El Pixl.js Se ha desconectado!',
    connfailed: '¡Conexión con Pixl.js fallida!'
  },
  labels: {
    name: 'Nombre',
    size: 'Tamaño',
    type: 'Tipo',
    remark: 'Anotación'
  },
  contxmenu: {
    del: 'Borrar…',
    rename: 'Renombrar…',
    prop: 'Propiedades…',
    format: 'Formatear…'
  },
  properties: {
    title: 'Propiedades',
    remark: 'Anotación',
    entermsg: 'Por favor ingrese una anotación',
    attrib: 'Atributos',
    hide: 'Oculto',
    readonly: 'Solo lectura',
    errupdate: '¡Error al actualizar propiedades!',
    remarktoolong: '¡Las anotaciones deben ser menores a 90 bytes!, lo cual es, 90 carácteres o 30 carácteres chinos (Longitud actual: ',
    remarktoolongend: ' Bytes）'
  },
  upload: {
    title: 'Subir Archivos',
    drag: 'Arrastre archivos aquí, o',
    click: 'haga clic para subirlos',
    maxsize: 'El tamaño máximo de la ruta es 63 bytes.',
    maxname: 'El nombre puede ser máximo 47 bytes.',
    closetitle: '¿Cerrar el diálogo?',
    closemessage: 'Cerrando el diálogo se eliminará el registro de elementos subidos. También se detendrá la cola de archivos que falta por subir',
    errupload: 'Fallo al subir: '
  },
  format: {
    title: 'Formatear',
    messrow1a: '¿Formatear  ',
    messrow1b: ' ?',
    messrow2: '¡Al formatear se perderán todos los datos!',
    messrow3: 'El formateo tarda aproximadamente 10 segundos, por favor sea paciente.',
    formatok: '¡Formateo Completo!',
    formaterr: '¡Formateo Fallido!'
  },
  del: {
    title: 'Borrar',
    message: '¿Borrar el elemento: ',
    messageend: ' ?',
    error: '¡Error al borrar!: ',
    deleteok: '¡Archivo borrado satisfactoriamente!'
  },
  dfumode: {
    title: 'Modo DFU',
    startconfirm: '¿Iniciar el modo DFU?',
    updateconfirm: 'Inicio del modo DFU satisfactorio. ¿Quieres lanzar la página de actualización de firmware en modo DFU?',
    updatetitle: 'Modo DFU Correcto'
  },
  oldfirm: {
    title: 'Advertencia de Actualización',
    message: 'La versión de tu dispositivo es muy vieja.  Por favor actualiza el dispositivo a la versión más reciente de firmware disponible antes de utilizar la función de carga de archivos.'
  },
  newfolder: {
    title: 'Nueva Carpeta',
    message: 'Ingrese el nombre de la nueva carpeta',
    newfoldererr: '¡Error al crear carpeta!:'
  },
  rename: {
    title: 'Renombrar',
    message: 'Por favor ingrese el nuevo nombre: ',
    errrename: '¡Error al cambiar el nombre!:',
    nametoolong: 'El tamaño máximo de la ruta es 63 bytes',
    pathtoolong: 'El nombre de archivo máximo es 47 bytes'
  },
  drive: {
    message: '(Disco no disponible [Código de Error: ',
    messageend: '])'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/es_ES.js